import React from "react";
import { Col, Image } from "react-bootstrap";
import getRecipientEmail from "../ulits/getRecipientEmail";
import { useAuthState } from "react-firebase-hooks/auth";
import { useCollection } from "react-firebase-hooks/firestore";
import "./Chat.css";
import { auth, db } from "../firebase";
import { Link } from "react-router-dom";

function Chat({ id, users }) {
  const [user] = useAuthState(auth);
  const recipientEmail = getRecipientEmail(users, user);
  // console.log(users);
  const [recipientSnapshot] = useCollection(
    db.collection("users").where("email", "==", getRecipientEmail(users, user))
  );
  const recipeint = recipientSnapshot?.docs?.[0]?.data();
  return (
    <Link
      to={`/chat/${id}/${recipientEmail}`}
      style={{ cursor: "default", textDecoration: "none" }}
    >
      <div className="chat text-center">
        {recipeint ? (
          <Col xs={6} md={4} className="chat_profile_img">
            <Image
              className="image-avatar"
              src={recipeint?.photoURL}
              roundedCircle
            />
          </Col>
        ) : (
          <Col xs={6} md={4} className="chat_profile_img">
            <Image
              className="image-avatar"
              src={recipientEmail[0]}
              roundedCircle
            />
          </Col>
        )}
        <h3 className="chat_profile_user_name">{recipientEmail}</h3>
      </div>
    </Link>
  );
}

export default Chat;
